module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/large-video-icon-6af3b8944220f8667a34d1bd6676d39d.png";